import Vue from 'vue'
import App from './App.vue'
// import Catalogue from "./Catalogue";
import router from './router'
import store from './store/innobun.js'
import Vuex from "vuex";
import VueI18n from "vue-i18n";

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPen, faTimes, faTimesCircle, faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faPinterest, faLinkedinIn, faXing } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

library.add(faPen, faTimes, faTimesCircle, faChevronLeft, faChevronRight, faChevronUp, faChevronDown, faSearch);
library.add(faFacebookF, faTwitter, faPinterest, faLinkedinIn, faXing);
library.add(faEnvelope);

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.use(Vuex);
Vue.use(VueI18n)

// @todo remove for production
Vue.config.performance = true;

const i18n = new VueI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages: translations
})

// i18n.path = (link) => {
//     if (i18n.locale === i18n.fallbackLocale) {
//         return `/${link}`
//     }
//
//     return `/${i18n.locale}/${link}`
// }

Vue.config.productionTip = false

var one = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    created() {
        // add leaving event listener
        window.addEventListener("beforeunload", this.handler) // @todo activate for production
    },
    methods: {
        handler: function handler(event) {
            // prepare leaving warning
            event.preventDefault();
            event.returnValue = '';
        }
    }
}).$mount('#innobun');


// var two = new Vue({
//     router,
//     store,
//     i18n,
//     render: h => h(Catalogue),
//     created() {
//         // add leaving event listener
//         // window.addEventListener("beforeunload", this.handler) // @todo activate for production
//     },
//     methods: {
//         handler: function handler(event) {
//             // prepare leaving warning
//             event.preventDefault();
//             event.returnValue = '';
//         }
//     }
// }).$mount('#catalogue')
